// Generates a 16-character temporary password for admin-created users.
// Charset deliberately excludes visually-ambiguous glyphs (0/O, 1/l/I)
// so the value can be read aloud or copied from a screen without
// transcription errors. Used by the three user-creation forms (global
// admin, org admin tab, organisation detail) which previously each
// inlined an identical copy.

const PASSWORD_CHARS =
  "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%";

export function generateTemporaryPassword(length = 16): string {
  let result = "";
  for (let i = 0; i < length; i++) {
    result += PASSWORD_CHARS.charAt(
      Math.floor(Math.random() * PASSWORD_CHARS.length),
    );
  }
  return result;
}
